<template>
  <!-- Header -->
  <div class="header">
    <div class="container">
      <router-link class="site-logo" to="/english/BTCInfo">
        <img src="@/assets/image/frontlogo.png" alt="Beef to China">
        <h5 class="sub-text">Your best explorer in the Chinese beef market</h5>
      </router-link>
      <!-- Mobile Button -->
      <a href="#" class="mobi-toggler"><i class="fa fa-bars"/></a>
      <!-- Navigation -->
      <div class="header-navigation pull-right font-transform-inherit">
        <ul class="nav-list">
          <!-- BTC Hub -->
          <li>
            <router-link to="/english/BTCInfo" class="dropdown-toggle" data-toggle="dropdown" data-target="#" href="javascript:;">BTC Info</router-link>
            <ul class="dropdown-menu">
              <li><router-link :to="{ path: '/english/section', query: { sectionid: '_exoress_en', sectiontitle: 'BTC Express' }}">BTC Express</router-link></li>
              <li><router-link :to="{ path: '/english/section', query: { sectionid: '_analysis_en', sectiontitle: 'BTC Analysis' }}">BTC Analysis</router-link></li>
            </ul>
          </li>
          <!-- BTC Data -->
          <li>
            <router-link to="/english/BTCData" class="dropdown-toggle" data-toggle="dropdown" data-target="#" href="javascript:;">BTC Data</router-link>
            <!-- <a class="dropdown-toggle" data-toggle="dropdown" data-target="#" href="javascript:;">BTC Data</a> -->
            <ul class="dropdown-menu">
              <li><router-link to="/english/BTCData/BeefExportToChina">Global Beef Exports to China</router-link></li>
              <li><router-link to="/english/BTCData/GlobalBeefExports">Global Beef Exports</router-link></li>
              <li><router-link to="/english/BTCData/ChinaBeefImportDataChart">China's Beef Imports (Trend)</router-link></li>
              <li><router-link to="/english/BTCData/ChinaBeefImportDataReport">China's Beef Imports (List)</router-link></li>
            </ul>
          </li>
          <li>
            <router-link to="/english/BTCPrice" class="dropdown-toggle" data-toggle="dropdown" data-target="#" href="javascript:;">BTC Price</router-link>
          </li>
          <li>
            <router-link to="/english/BTCMarket" class="dropdown-toggle" data-toggle="dropdown" data-target="#" href="javascript:;">BTC Market</router-link>
          </li>
          <li>
            <!-- <router-link to="/english/BTCPlant" class="dropdown-toggle" data-toggle="dropdown" data-target="#" href="javascript:;">BTC Est.</router-link> -->
            <a class="dropdown-toggle" data-toggle="dropdown" data-target="#" href="javascript:;" @click="setMarketIndexTab">BTC Est.</a>
          </li>
          <li>
            <router-link style="height: 84px; padding: 22px 12px;" to="/Pork/English/PTCInfo" class="dropdown-toggle" data-toggle="dropdown" data-target="#" href="javascript:;"><img src="@/assets/image/pork_logo_en.png" height="40px;"></router-link>
          </li>
          <!-- Search -->
          <li class="menu-search">
            <span class="sep"/>
            <i class="fa fa-search search-btn" @click="handelClick"/>
            <div :class="{ showSearchBox: showSearch }" class="search-box">
              <form>
                <div class="input-group col-xs-5 pull-left" style="padding-right: 10px;">
                  <select v-model="country" type="text" class="form-control">
                    <option value="" label="All Countries"/>
                    <option v-for="item in countryOptions" :key="item.value" :value="item">{{ $t(`message['${item}']`) }}</option>
                    <option value="_other" label="Other"/>
                  </select>
                </div>
                <div class="input-group col-xs-7 pull-left">
                  <input v-model="keyWords" type="text" placeholder="Please Input Keyword" class="form-control">
                  <span class="input-group-btn">
                    <button class="btn btn-primary" @click.prevent="handleSearch">Search</button>
                  </span>
                </div>
              </form>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { newsCountryData } from '@/utils/dictionary'
export default {
  name: 'Header',
  data() {
    return {
      country: '',
      keyWords: '',
      showSearch: false,
      countryOptions: newsCountryData
    }
  },
  created() {
    window.addEventListener('mouseup', this.handleMouseup)
  },
  methods: {
    handelClick() {
      this.showSearch = !this.showSearch
      return this.showSearch
    },
    handleMouseup(event) {
      if (this.showSearch && (event.target.nodeName !== 'INPUT' && event.target.nodeName !== 'SELECT')) {
        this.showSearch = false
      }
    },
    handleSearch() {
      if (this.country || this.keyWords) {
        this.$router.push({ path: '/english/search', query: { keywords: this.keyWords, country: this.country }})
      }
      this.keyWords = ''
      this.country = ''
    },
    setMarketIndexTab() {
      this.$store.commit('SET_MARKETINDEXTAB', '_approve_status')
      this.$router.push('/english/BTCPlant')
    }
  }
}
</script>

<style scoped>
.header { margin-bottom: 8px!important; }
a { text-decoration: none; padding: 14px }
.site-logo { margin: 0 }
.site-logo:link    { color: #E02222 }
.site-logo:visited { color: #E02222 }
.site-logo:hover   { color: #E02222 }
.site-logo:active  { color: #E02222 }
.sub-text { font-size: 13px; margin: 2px 0 0 0 }
.nav-list { font-size: 19px; }
.showSearchBox { display: inline!important }
.mobi-toggler { margin-left: 1px;}
</style>



// WEBPACK FOOTER //
// src/views/layout_en/components/Navigation/index.vue